
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import { HttpClient } from '@angular/common/http';
import {CustomerInfo} from "@webmate-web-core/shared/types/customer";

@Injectable({
  providedIn: 'root'
})
export class CustomerApi {

    constructor (public OAuth2AuthService: AuthService, private http: HttpClient) {}

    getCustomerInfo$(): Observable<CustomerInfo> {
        return this.http.get<CustomerInfo>('/customer/info');
    }

}
